import { render, staticRenderFns } from "./phoneHome.vue?vue&type=template&id=7199193d&scoped=true"
import script from "./phoneHome.vue?vue&type=script&lang=js"
export * from "./phoneHome.vue?vue&type=script&lang=js"
import style0 from "./phoneHome.vue?vue&type=style&index=0&id=7199193d&prod&lang=css"
import style1 from "./phoneHome.vue?vue&type=style&index=1&id=7199193d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7199193d",
  null
  
)

export default component.exports